import { jsx as _jsx } from "react/jsx-runtime";
import { FilePresentation } from './FilePresentation';
import { FolderPresentation } from './FolderPresentation';
export const FileFolderPresentation = ({ contentTypeName, data, displayFields, onClick, path, withLink }) => {
    if ('folderLabel' in data) {
        return (_jsx(FolderPresentation, { contentTypeName: contentTypeName, data: data, displayFields: displayFields, onClick: onClick, path: path, withLink: withLink }));
    }
    return (_jsx(FilePresentation, { contentTypeName: contentTypeName, data: data, displayFields: displayFields, onClick: onClick, path: path, withLink: withLink }));
};
//# sourceMappingURL=FileFolderPresentation.js.map